import React, { useEffect } from 'react'
import { GoalId, GoalWithProgress } from '../../services/api.types'
import YumCustomEntryWrapper from '../../components/YumCustomEntry/YumCustomEntryWrapper'
import NotificationsWrapper from '../../components/Notification/NotificationsWrapper'
import { store } from '../../index'
import { push } from 'connected-react-router'
import { isNative } from '../../common/helpers/isNative'
import YumUserProgressCelebration from '../../components/YumUserProgressCelebration/YumUserProgressCelebration'

export interface IChallengeMeStateProps {
  goalId: GoalId
  goal?: GoalWithProgress
}

export interface IChallengeMeDispatchProps {
  getSingleChallengeWithProgress(payload: { goalId: GoalId }): void
  cancelGetChallengesWithProgress(): void
  resetManualEntryInProgress(): void
}

type IChallengeMeProps = IChallengeMeStateProps & IChallengeMeDispatchProps

export default function ChallengeMe(props: IChallengeMeProps) {
  const { goalId, goal, getSingleChallengeWithProgress, cancelGetChallengesWithProgress, resetManualEntryInProgress } =
    props

  useEffect(() => {
    // Cancel any ongoing getChallengesWithProgress request when navigating to this view
    cancelGetChallengesWithProgress()
    // Then load the single challenge
    getSingleChallengeWithProgress({ goalId })
    // Just in case, reset manual entry in progress state when navigating to this view
    resetManualEntryInProgress()
  }, [goalId, getSingleChallengeWithProgress, cancelGetChallengesWithProgress, resetManualEntryInProgress])

  if (!goal) return null

  if (!goal.splitRankingView) {
    console.log(`Redirecting to old ranking view`)
    store.dispatch(push(`/challenges/${goalId}/ranking`))
  }

  return (
    <div style={{ paddingBottom: '1px' }}>
      <NotificationsWrapper />

      {/* Progress celebration for native apps */}
      {isNative() && goal ? <YumUserProgressCelebration goal={goal} /> : null}

      <YumCustomEntryWrapper goal={goal} showManualEntry={true} isMeView={true} />
    </div>
  )
}
